var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{ref:"btn",staticClass:"mt-button",attrs:{"type":_vm.type,"icon":_vm.icon,"round":_vm.round,"circle":_vm.circle},on:{"click":_vm._click}},[_vm._v(_vm._s(_vm.txt))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-754842f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mt/MtButton/index.vue
// module id = null
// module chunks = 